import React from 'react';
import createSelector from '@configuratorware/configurator-frontendgui/Utils/Function/createSelector';
import {
  getItem,
  getSelectedVariantIdentifier,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { forEach } from 'lodash';
import TitleDisplay from '../../Components/TitleDisplay';

const getItemGroupChildren = (item) => {
  const { itemGroup } = item;
  if (!itemGroup) {
    return [];
  }
  return itemGroup.children || [];
};

export const createPropsFromState = createSelector(
  getItem,
  getSelectedVariantIdentifier,
  (item, selectedVariantIdentifier) => {
    const variants = [];
    // const host = getConf('network.host');
    getItemGroupChildren(item).forEach((option) => {
      // const children = option.itemGroup ? option.itemGroup.children : [];
      // const childIdentifiers = children.map((child) => child.identifier);
      variants.push({
        key: option.identifier,
        title: option.itemgroupentryTitle,
        value: option.identifier,
      });
    });

    let selectedVariant = selectedVariantIdentifier;
    if (variants.length > 0 && get(variants[0], 'sizes', []).length > 0 && selectedVariantIdentifier) {
      variants.forEach((variant) => {
        if (variant.sizes.find((size) => size === selectedVariantIdentifier)) {
          selectedVariant = variant.value;
        }
      });
    }
    return {
      selectedVariantIdentifier,
      selectedVariant,
      title: `${item.identifier} ${item.title}`,
    };
  },
);

const mapStateToProps = ({ configurator }) => ({
  ...createPropsFromState(configurator),
});

export default connect(mapStateToProps)((props) => (
  <TitleDisplay
    {...props}
    Component={TitleDisplay}
  />
));
